<div class="flex flex-col gap-5 p-1">
        <div class="flex flex-col md:flex-row w-full items-stretch h-fit gap-5">
            <div class="w-full">
                <app-my-registration-stats></app-my-registration-stats>
            </div>
            <div class="w-full">
                <app-my-call-stats></app-my-call-stats>
            </div>
            <div class="w-full">
                <app-recruiting-scheduled-activities 
                    [staffId]="currentStaffId()" 
                    timeframe="day"
                    [maxHeight]="168">
                </app-recruiting-scheduled-activities>
            </div>
        </div>
        <div class="flex flex-col md:flex-row w-full items-stretch h-fit gap-5">
            <div class="w-full">
                <app-my-saved-lead-searches></app-my-saved-lead-searches>
            </div>
            <div class="w-full">
                <app-my-potential-trips [staffId]="currentStaffId()"></app-my-potential-trips>
            </div>
            <div class="w-full">
                <app-recruiting-scheduled-activities 
                    [staffId]="currentStaffId()" 
                    timeframe="week"
                    [maxHeight]="332">
                </app-recruiting-scheduled-activities>
            </div>
        </div>
        <div>
            <app-all-scheduled-activities [staffId]="currentStaffId()" [category]="2"></app-all-scheduled-activities>
        </div>
        <!-- PPM Registration Stats - Only show if user can view admin stats -->
        <div *ngIf="canViewAdminStats()">
            <app-registration-stats></app-registration-stats>
        </div>
        
        <!-- Location Recruiting and Renewal Progress - Only show if user can view team stats -->
        <div *ngIf="canViewTeamStats()" class="flex flex-col md:flex-row w-full items-stretch h-fit gap-5">
            <div class="w-full">
                <app-location-recruiting></app-location-recruiting>
            </div>
            <div class="w-full">
                <app-renewal-progress></app-renewal-progress>
            </div>
        </div>
        
        <!-- Registration Leaderboard - Only show if user can view team stats -->
        <div *ngIf="canViewTeamStats()">
            <app-registration-leaderboard></app-registration-leaderboard>
        </div>
        
        <!-- Assist Leaderboard - Only show if user can view team stats -->
        <div *ngIf="canViewTeamStats()">
            <app-assist-leaderboard></app-assist-leaderboard>
        </div>
        
        <!-- PPM Call Stats - Only show if user can view admin stats -->
        <div *ngIf="canViewAdminStats()">
            <app-call-stats></app-call-stats>
        </div>
        
        <!-- Call Leaderboard - Only show if user can view team stats -->
        <div *ngIf="canViewTeamStats()">
            <app-call-leaderboard></app-call-leaderboard>
        </div>
        
        <!-- Location Quick Notes - Only show if user can view team stats -->
        <div *ngIf="canViewTeamStats()">
            <app-location-quicknotes></app-location-quicknotes>
        </div>
    </div>